import { createRouter, createWebHashHistory, Router, RouteRecordRaw } from "vue-router";
import CxLogin from "@/app/CxLogin.vue";
import CxReset from '@/app/CxReset.vue';
import CxRecovery from '@/app/CxRecovery.vue';
import CxLogout from '@/app/CxLogout.vue'

const history = createWebHashHistory();
const routes: Array<RouteRecordRaw> = [
  { name: 'not-found', path: '/:catchAll(.*)', redirect: 'login' },
  { name: 'root', path: '/', redirect: 'login' },
  { name: 'login', path: '/login', component: CxLogin },
  { name: 'recovery', path: '/recover/', component: CxRecovery },
  { name: 'reset', path: '/reset/:token/:uidb64', component: CxReset },
  { name: 'logout', path: '/logout', component: CxLogout }
];
const vueRouterInstance: Router = createRouter({ history, routes });

export default vueRouterInstance;
